import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './index.css';
import App from './App';
import { APP_ENV, BUILD_COMMIT } from './config/environment';

dayjs.extend(utc);
dayjs.extend(timezone);

console.info(`BotBridge ${APP_ENV} build, commit ${BUILD_COMMIT}`);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);